import React from 'react';
import { Section } from '../ui/Section';
import { Accordion } from '../ui/Accordion'; // We need to create this
export function FAQ() {
  const faqs = [{
    question: '¿Es un libro físico o digital?',
    answer: 'Es una guía 100% digital (eBook). Esto significa que tendrás acceso inmediato en tu correo electrónico segundos después de tu compra. Puedes leerlo en tu celular, tablet o computadora.'
  }, {
    question: '¿Necesito comprar suplementos o tés especiales?',
    answer: '¡No! Todo el método se basa en alimentos naturales que encuentras en el supermercado y técnicas manuales/posturales. No te venderemos pastillas ni batidos.'
  }, {
    question: '¿Sirve si tengo poco tiempo?',
    answer: 'Absolutamente. Fue creada pensando en la mujer que trabaja. Las rutinas de alivio toman menos de 10 minutos y muchos consejos se aplican mientras estás en la oficina.'
  }, {
    question: '¿Qué pasa si no me funciona?',
    answer: 'Tienes nuestra garantía de 30 días. Si no sientes alivio, te devolvemos tu dinero. Queremos que compres con total tranquilidad.'
  }, {
    question: '¿Cómo recibo los bonos?',
    answer: 'Los bonos (El Menú de 3 Días y el Checklist de Emergencia) vienen incluidos en la misma descarga que recibirás en tu correo.'
  }];
  return <Section id="faq" background="cream" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <div className="text-center mb-12" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#4A3B32] mb-4" data-id="element-19">
            Preguntas Frecuentes
          </h2>
          <p className="text-[#5D5D5D]" data-id="element-20">
            Todo lo que necesitas saber antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-21">
          {faqs.map((faq, index) => <Accordion key={index} title={faq.question} data-id="element-22">
              {faq.answer}
            </Accordion>)}
        </div>
      </div>
    </Section>;
}